import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import FormCheckSquare from 'components/LM/common/FormCheckSquare';
import VoiceRelationsIcons from 'components/LM/common/VoiceRelationsIcons'
import DateFormat from "components/LM/common/DateFormat";
import ProfileImage from "components/LM/common/ProfileImage";
import TooltipWrapper from "components/LM/common/TooltipWrapper";

import 'components/LM/Voice/Item.scss';

function Item(props) {

	const { editType, type, editMode, profileId, disabled, checked, onToggleItem, addedAt, className, pictureUrl } = props;

	let checkbox;
	if (editMode) {
		checkbox = (
			<Col md="auto" className="p-0 a	d-flex align-items-center">
				<FormCheckSquare className="ml-2 mr-2" width="18" checked={checked} disabled={disabled} onChange={onToggleItem} />
			</Col>
		);
	}

    const relationDate = addedAt ? (
        <TooltipWrapper
            placement="top"
            tooltip={<>Linked at: <DateFormat>{addedAt}</DateFormat></>}
        >
            <div className="media-type text-black-50 mb-0 details">
                <DateFormat>{addedAt}</DateFormat>
            </div>
        </TooltipWrapper>
    ) : "";

	return (
		<Container fluid className={className}>
			<Row>
				{ editType && (checkbox)}
				<Col md="auto" className={`p-0`} id="profile-network-icon">
					<VoiceRelationsIcons type={type} size="19" />
				</Col>
				<Col md="auto" id="profile-image" className="d-flex align-items-center custom-padding">
					<ProfileImage id={profileId} type={type} pictureUrl={pictureUrl} className="rounded-circle" width="33" height="33" />
				</Col>
				<Col id="profile-information" className="custom-padding text-ellipsis">
					{props.children}
					{relationDate}
				</Col>
			</Row>
		</Container>
	)
}

export default Item;
